import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UsedDownloadCodeDto {
  @Field()
  code!: string
}
